import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { AxiosResponse } from 'axios'
import { ChartView } from 'src/Libs/chart-kit'
import { objectApiResult } from '@e3dc-react/shell/Libs/ApiHelpers'
import { CoreHistoryModel, PowermeterHistoryModel, WallboxHistoryModel } from '../models/history-data'

export interface HistoryPayloadBasedOnView {
  from: number
  to: number
  view: ChartView
  includeFirst?: boolean
  includeLast?: boolean
  isRawData?: boolean
}

/**
 * Fetches history data based on the step/view (day, week, month, year) selected.
 * @beta This logic is part of the system chart proof of concept and should not be made available to users yet
 */
export const fetchCoreHistoryDataBasedOnView = (
  storageId: string,
  authFetch: <T>(props: FetchProps) => Promise<AxiosResponse<T>>,
  payload: HistoryPayloadBasedOnView
): Promise<CoreHistoryModel[]> => {
  return authFetch({
    path: `storages/${storageId}/history-values/steps`,
    method: 'GET',
    payload: {
      ...payload,
      calculateDiff: true,
    },
  })
    .then(r => objectApiResult(r.data as any)) //eslint-disable-line
    .catch(e => {
      throw e
    }) as Promise<CoreHistoryModel[]>
}

/**
 * Fetches powermeter data based on the step/view (day, week, month, year) selected.
 * @beta This logic is part of the system chart proof of concept and should not be made available to users yet
 */
export const fetchPowermeterHistoryDataBasedOnView = (
  storageId: string,
  powerMeterId: string,
  authFetch: <T>(props: FetchProps) => Promise<AxiosResponse<T>>,
  payload: HistoryPayloadBasedOnView
): Promise<PowermeterHistoryModel[]> => {
  return authFetch({
    path: `storages/${storageId}/powermeter-values/${powerMeterId}/steps`,
    method: 'GET',
    payload: {
      ...payload,
      calculateDiff: true,
    },
  })
    .then(r => objectApiResult(r.data as any)) //eslint-disable-line
    .catch(e => {
      throw e
    }) as Promise<PowermeterHistoryModel[]>
}

/**
 * Fetches wallbox data based on the step/view (day, week, month, year) selected.
 * @beta This logic is part of the system chart proof of concept and should not be made available to users yet
 */
export const fetchWallboxHistoryDataBasedOnView = (
  storageId: string,
  wallboxId: string,
  authFetch: <T>(props: FetchProps) => Promise<AxiosResponse<T>>,
  payload: HistoryPayloadBasedOnView
): Promise<WallboxHistoryModel[]> => {
  return authFetch({
    path: `wallboxes/${storageId}/${wallboxId}/historydata/steps`,
    method: 'GET',
    payload: {
      ...payload,
      calculateDiff: true,
    },
  })
    .then(r => objectApiResult(r.data as any)) //eslint-disable-line
    .catch(e => {
      throw e
    }) as Promise<WallboxHistoryModel[]>
}
